/**
 * @param {Record<string, unknown>} payload
 * @param {{ accessToken?: string | null, auth?: { getSession: () => Promise<any> }, fetchImpl?: (...args: any[]) => Promise<any> }} [options]
 */
export async function postRunAnalysis(payload, { accessToken, auth, fetchImpl = fetch } = {}) {
  let token = accessToken;
  if (!token) {
    if (!auth || typeof auth.getSession !== "function") {
      throw new Error("Unable to verify the signed-in session.");
    }
    const { data, error } = await auth.getSession();
    if (error) throw new Error("Unable to verify the signed-in session.");
    token = data?.session?.access_token;
  }
  if (!token) throw new Error("Please sign in before starting an analysis.");

  return fetchImpl("/api/run-analysis", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  });
}
